var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('ButtonGoHome'),_c('AppContentHeaderFormBijstand',{attrs:{"title":"Formulario pa aplicacion di bijstand"}}),_c('AppContentPreface'),_c('AppFormNewBijstand')],1)}
var staticRenderFns = []

export { render, staticRenderFns }